import React from 'react';
import classnames from 'classnames';

import styles from './Loader.module.scss';

interface LoaderProps extends StyleProps {
  /** @string Loader color */
  color?: 'White' | 'Red';
  /** @boolean This will give you a fixed-position Loader icon in the middle of the page. Handy for when you need to load a whole page before rendering it. */
  fullPage?: boolean;
  /** @number Loader width */
  width?: number;
  /** @number Loader height */
  height?: number;
}

export const Loader: React.FC<LoaderProps> = ({
  className,
  color,
  fullPage,
  width = 40,
  height = 40,
}) => {
  const loader = (
    <svg
      className={classnames(className, styles.loader, [styles[`color-${color}`]])}
      width={width}
      height={height}
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#000"
        d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
      />
    </svg>
  );

  if (fullPage) {
    return <div className={styles.fullPage}>{loader}</div>;
  }
  return loader;
};
